import React, { useState } from "react";

export default function Maplee() {
  const images = [`${process.env.PUBLIC_URL}/Maplee4.png`];

  const screenshots = [
    {
      title: "After",
      image: `${process.env.PUBLIC_URL}/maplee.screenshot.cropped2.PNG`,
    },
    {
      title: "Before",
      image: `${process.env.PUBLIC_URL}/maplee.screenshot.before2.PNG`,
    },
  ];

  const [currentPage, setCurrentPage] = useState(0);
  const isMobile = window.innerWidth < 768;

  const nextPage = () => {
    setCurrentPage((prev) => (prev + 1) % screenshots.length);
  };

  const prevPage = () => {
    setCurrentPage((prev) =>
      prev === 0 ? screenshots.length - 1 : prev - 1
    );
  };

  return (
    <div className="flex flex-col ">
      {/* 🔹 Top Section */}
      <div
        className="min-h-screen flex flex-col bg-gray-900 text-white px-2 md:px-8 py-20"
        style={{
          backgroundImage: `url(${process.env.PUBLIC_URL}/${isMobile ? "Canadian-Vendor-Mobile.png" : "Canadian-Vendor-4.png"})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          backgroundAttachment: isMobile ? "scroll" : "fixed",
        }}
      >
        <div className="flex-grow flex md:flex-row items-stretch justify-center gap-12 px-8 pt-20">
          <div className="w-full md:w-1/2 hidden md:flex justify-center items-stretch">
            <img
              src={images[0]}
              alt="Maplee Multi-Vendor Marketplace"
              className="w-full h-full rounded-2xl shadow-lg object-cover transition duration-1000"
            />
          </div>

          <div className="bg-black/60 backdrop-blur-md p-8 rounded-2xl shadow-lg w-auto flex flex-col justify-center">
            <h1 className="text-4xl font-bold text-purple-400 mb-6">
              Maplee Multi-Vendor Marketplace
            </h1>
            <p className="text-gray-300 leading-relaxed text-lg mb-6">
              Developed a scalable eCommerce platform enabling independent vendors to sell products through a centralized WordPress/WooCommerce system.
            </p>
            <ul className="list-disc list-outside pl-6 text-left text-gray-300 text-md md:text-lg space-y-4 mb-6">
              <li>
                Marketplace Integration: Customized WooCommerce with WCFM to support multiple vendors, product listings, and individual storefronts.
              </li>
              <li>
                Responsive UI: Designed a clean, mobile-friendly interface with Elementor and custom CSS.
              </li>
              <li>
                Performance Optimization: Implemented caching, lazy loading, and image optimization (WebP).
              </li>
              <li>
                Admin Tools: Included vendor competition tools and category-level product featuring.
              </li>
            </ul>
            <p className="text-gray-300 leading-relaxed text-lg mt-2">
              Created a user-friendly, high-performance platform for vendors to grow their businesses and reach wider audiences.
            </p>
          </div>
        </div>
      </div>

      {/* 🔹 Screenshot Slider Section */}
      <div
        className="min-h-screen flex flex-col items-center justify-center bg-gray-800 text-white px-4 md:px-8 pt-10"
        style={{
          backgroundImage: `url(${process.env.PUBLIC_URL}/BG3.png)`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <h2 className="text-3xl font-bold text-purple-300 mb-6">Before / After Comparison</h2>

        <div className="bg-black/60 backdrop-blur-md p-8 rounded-2xl shadow-lg max-w-4xl w-full text-center mb-20">
          <h3 className="text-3xl font-bold mb-6">{screenshots[currentPage].title}</h3>
          <img
            src={screenshots[currentPage].image}
            alt={screenshots[currentPage].title}
            className="w-full max-h-full object-contain rounded-xl mx-auto"
          />
          <div className="mt-6 flex justify-between">
            <button
              onClick={prevPage}
              className="px-6 py-2 bg-purple-600 hover:bg-purple-700 rounded-full transition"
            >
              ← Previous
            </button>
            <button
              onClick={nextPage}
              className="px-6 py-2 bg-purple-600 hover:bg-purple-700 rounded-full transition"
            >
              Next →
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}